export const initChunkErrorHandler = () => {
  const isChunkError = (message?: string) =>
    message?.includes('Failed to fetch dynamically imported module') ||
    message?.includes('text/html') ||
    message?.includes('Importing a module script failed') ||
    message?.includes('Failed to load module script');

  const handleChunkError = async () => {
    // Prevent reload loop — only attempt once per session
    if (sessionStorage.getItem('chunk-reload-attempted')) {
      console.error('Chunk reload already attempted this session. Stopping to prevent loop.');
      return;
    }

    sessionStorage.setItem('chunk-reload-attempted', 'true');
    console.warn('Chunk load error detected. Clearing cache and reloading...');

    // Clear all caches and wait for it to finish before reloading
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }

    window.location.reload();
  };

  // Handle runtime errors (including chunk loading failures)
  window.addEventListener('error', (event) => {
    if (isChunkError(event.message)) {
      handleChunkError();
    }
  });

  // Handle promise rejections from dynamic imports
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkError(event.reason?.message)) {
      handleChunkError();
    }
  });
};
